// extracted by mini-css-extract-plugin
module.exports = {"HowToCard":"HowToCard_HowToCard__1pxsi index_body__1cmOq","header":"HowToCard_header__mueKU"};